class Carousel extends HTMLElement {
  constructor() {
    super();

    this.desktopPerPage = this.dataset.desktopPerPage || 4;
    this.mobilePerPage = this.dataset.mobilePerPage || 1;
    this.type = this.dataset.type || 'slide';
    this.perMove = this.dataset.perMove || '1';
    this.gap = this.dataset.gapBetweenSlides || 10;
    this.gapMobile = this.dataset.gapBetweenSlidesOnMobile || 10;

    // Data attribute string matching for correct boolean value
    this.showArrows = this.dataset.showArrows === 'true' || false;
    this.showArrowsOnMobile = this.dataset.showArrowsOnMobile === 'true' || false;
    this.showDots = this.dataset.showDots === 'true' || false;
    this.showDotsOnMobile = this.dataset.showDotsOnMobile === 'true' || false;
    this.mobileOnly = this.dataset.mobileOnly === 'true' || false;
    this.desktopOnly = this.dataset.desktopOnly === 'true' || false;
  }

  connectedCallback() {
    if (!this.classList.contains('splide')) return;

    this.initCarousel();
  }

  initCarousel() {
    // More option available here https://splidejs.com/documents/
    // This slider can be customized as require check the above doc before adding any new 
    this.carousel = new Splide(this, {
      type: this.type,
      perPage: this.desktopPerPage,
      perMove: this.perMove,
      gap: this.gap,
      arrows: this.showArrows,
      pagination: this.showDots,
      destroy: this.mobileOnly,
      breakpoints: {
        750: {
          perPage: this.mobilePerPage,
          arrows: this.showArrowsOnMobile,
          pagination: this.showDotsOnMobile,
          gap: this.gapMobile,
          destroy: this.desktopOnly
        }
      },
    });

    this.carousel.mount();

    // Fixing dots not appearing issue
    this.carousel.refresh();
  }
}

customElements.define('carousel-component', Carousel);

class MediaCarousel extends Carousel {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    document.querySelector('[name="id"]').addEventListener('change', this.onMainInputChange.bind(this));
  }

  onMainInputChange(e) {
    this.productJSON = this.productJSON || JSON.parse(document.querySelector('[data-product-json]').textContent);
    this.imageTags = Array.from(document.querySelectorAll('[data-filter-by-selected-options] img'));
    const hasFeaturedMedia = this.productJSON.variants.some(variant => variant.featured_media);
    const hasColorOption = this.productJSON.options.some(option =>
      option.toLowerCase().includes('color') || option.toLowerCase().includes('colour')
    );
    
    // Exit early if no variants have featured media or product has no color options
    if (!hasFeaturedMedia || !hasColorOption) {
      return;
    }

    // Extract only selected color option values
    const selectedColorOptions = this.selectedOptionValues.map((selectedValue, index) => {
      const optionName = this.productJSON.options[index]?.toLowerCase();
      const isColorOption = optionName.includes('color') || optionName.includes('colour');
      return isColorOption ? selectedValue : undefined;
    });

    // Filter variants that match the selected color options
    const matchingVariants = this.productJSON.variants.filter(variant => 
      variant.options.every((option, index) => 
        selectedColorOptions[index] === undefined || option === selectedColorOptions[index]
      )
    );

    // Update image visibility based on matching variants
    this.imageTags.forEach(img => {
      const imageId = Number(img.getAttribute('data-image-id'));
      const isVariantImage = matchingVariants.some(variant => variant?.featured_media?.id === imageId);
      img.closest('li').classList.toggle('splide__slide', isVariantImage);
    });
  
    this.carousel.refresh();
  }

  get selectedOptionValues() {
    return Array.from(document.querySelectorAll('variant-swatch fieldset')).map(
      (fieldset) => fieldset.querySelector('input:checked')?.value
    );
  }
}

customElements.define('media-carousel', MediaCarousel);

